export default __webpack_public_path__ + "static/persons-animated-b4331ad0f3f9cdd4fd5c398385d2b0b1.gif";